<!-- 电子秤设置 -->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <el-row v-for="(ec, idx) in form.ecsetting" :key="idx">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item :label="msg('设备名')">
            <el-input v-model="ec.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item :label="msg('COM端口')">
            <el-input v-model="ec.port"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('取值表达式')" label-width="120px">
            <el-input v-model="ec.express" type="textarea" :rows="5"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('操作')">
            <div>
              <el-switch v-model="ec.disabled"
                         inactive-text="是否激活" @click.native="setDefault(idx, 'ecsetting')"
                         :active-value="1" :inactive-value="0"
                         active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <el-link style="margin-left:20px;" icon="el-icon-delete"
                       type="danger" :underline="false"
                       @click="form.ecsetting.splice(idx, 1);">{{ msg('删除') }}
              </el-link>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align:center;">
        <el-button type="primary" @click="addEc()" plain size="mini">添加更多</el-button>
      </div>
      <el-alert title="取值表达式使用js代码， ${value}表示从电子秤读取到的数据">
        <template>
                            <pre>
(function(){
    var val = "${value}";
    val = val.split("=");
    val = val[val.length-2];
    return (val.split("").reverse().join(""))*1;
})();
                            </pre>
        </template>
      </el-alert>
      <el-alert title="如果您不知道从电子秤读取到的数值是什么样子，请点击下面的按钮下载测试工具">
        <template>
          <a :href="comTest">点击下载</a>
        </template>
      </el-alert>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{
          msg('确定')
        }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingScale",
  data() {
    return {
      comTest: this.$kit.api.user.comTest,
      xgroup: 'ECSETTING',  //电子秤group
      form: {
        ecsetting: [], //电子秤微调设置
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.ecsetting = [];
      let arr = data
      //相同的xkey，表示同一个设置
      //电子秤数据
      if (arr.length > 0) {
        arr.forEach(a => {
          if (a.xvalue) {
            let set = JSON.parse(a.xvalue);
            let ecset = {
              id: a.id,
              disabled: a.disabled,
              name: set.name,
              port: set.port,
              express: set.express,
              owner: a.owner
            }
            _this.form.ecsetting.push(ecset);
          }
        });
      }
    },
    addEc() {
      this.form.ecsetting.push({
        id: null,
        disabled: 0,
        name: null,
        port: 9600,
        express: null,
        owner: null,
      });
    },
    setDefault(idx, key){ //设置默认值
      let arr = this.form[key];
      if(arr.length>0){

        let disabled = arr[idx].disabled;
        if(disabled == 1){
          for(let i = 0; i<arr.length; i++){
            let item = arr[i];
            if(i!=idx){
              item.disabled = 0;
            }
          }
        }
      }
    },
    update() {
      let datas = [];
      //构建电子秤设置
      for (let i = 0; i < this.form.ecsetting.length; i++) {
        let e = this.form.ecsetting[i];
        let key = this.xgroup + i;
        datas.push({
          id: e.id,
          disabled: e.disabled,
          xkey: key,
          xlabel: e.name,
          xvalue: JSON.stringify({
            name: e.name,
            port: e.port,
            express: e.express
          }),
          owner: e.owner ? e.owner : null,
          xgroup: this.xgroup
        });
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>